import { BlockWrapper, defineBlock, smartProps, useInspectorControl } from '@smartfire/js-block-engine';
import { useSmartField } from '@smartfire/wordpress-smartforms';
import React from 'react';
import style from './block.module.scss';

const Inspector = React.lazy(() => import('./Inspector'));

const Block = ({ type, placeholder }) => {
    useInspectorControl(Inspector);

    const { field } = useSmartField({
        smartProp: 'input',
        type,
        defaults: {
            name: 'input',
        },
    });

    return (
        <BlockWrapper.Div className={style.block}>
            <input
                className={style.input}
                type={type}
                placeholder={placeholder}
                name={field?.name}
                id={field?.id}
                required={field?.required ?? false}
            />
        </BlockWrapper.Div>
    );
};

export default defineBlock({
    Block,
    setup: {
        title: 'Formulaire - Input',
        parent: ['smartfire/contact-form---form'],
    },
    smartProps: {
        input: smartProps.object,
        label: smartProps.string.withDefault('Prénom'),
        type: smartProps.string.withDefault('text'),
        placeholder: smartProps.string.withDefault(''),
    },
});
